import { POST } from "metabase/api/legacy-client";

type InternalAnalyticsEvent = {
  op: "inc" | "dec" | "set" | "observe" | "clear";
  metric: string;
  labels?: Record<string, string> | null;
  amount?: number;
};

const postEvents = POST("/api/analytics/internal");

export function postInternalAnalytics(
  events: InternalAnalyticsEvent[],
): Promise<void> {
  return postEvents({ events });
}
